import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import type React from 'react';
import UploadOptionsLoadingIndicator from './UploadOptionsLoadingIndicator';
import {
  UploadFile as UploadIcon,
  ArrowRight as ArrowRightIcon,
} from '@mui/icons-material';
import ErrorIcon from '../utils/icons/ErrorIcon';
import { FormattedMessage } from 'react-intl';

type UploadOptionsMenuItemProps = Omit<
  MenuItemProps,
  | 'id'
  | 'onClick'
  | 'onKeyDown'
  | 'aria-controls'
  | 'aria-expanded'
  | 'aria-haspopup'
  | 'children'
> & {
  id: string;
  loading: boolean;
  hasError: boolean;
  uploadOptionsMenuId: string;
  uploadOptionsMenuOpen: boolean;
  onOpenUploadOptionsMenu: (
    event: React.MouseEvent<HTMLLIElement> | React.KeyboardEvent<HTMLLIElement>,
  ) => void;
};

const UploadOptionsMenuItem = ({
  id,
  loading,
  hasError,
  uploadOptionsMenuId,
  uploadOptionsMenuOpen,
  onOpenUploadOptionsMenu,
  ...props
}: UploadOptionsMenuItemProps) => (
  <MenuItem
    id={id}
    onClick={onOpenUploadOptionsMenu}
    onKeyDown={(e: React.KeyboardEvent<HTMLLIElement>): void => {
      if (e.key === 'ArrowRight') {
        onOpenUploadOptionsMenu(e);
      }
    }}
    aria-controls={uploadOptionsMenuOpen ? uploadOptionsMenuId : undefined}
    aria-expanded={uploadOptionsMenuOpen ? 'true' : undefined}
    aria-haspopup
    {...props}
  >
    <ListItemIcon>
      {loading ? (
        <UploadOptionsLoadingIndicator color={hasError ? 'error' : undefined} />
      ) : hasError ? (
        <ErrorIcon />
      ) : (
        <UploadIcon />
      )}
    </ListItemIcon>
    <ListItemText>
      <FormattedMessage id="portfolio.challenge.files.add.menu.items.upload_file.label" />
    </ListItemText>
    <ArrowRightIcon />
  </MenuItem>
);

export default UploadOptionsMenuItem;
